/* ------------------------------------------------------------------------------
@name: Section2
@description: Section2
--------------------------------------------------------------------------------- */

const Section2 = (() => {
  // - section2
  const handleSection2 = () => {
    // init controller
    const controller = new ScrollMagic.Controller();

    const section_2 = new ScrollMagic.Scene({
      triggerElement: ".section__2__trigger",
      offset: 700,
      triggerHook: 0.5,
    })
      .setTween(".peta-2a", 0.3, {
        opacity: 1,
      })
      .addTo(controller);

    const section_2a = new ScrollMagic.Scene({
      triggerElement: ".section__2__trigger",
      duration: 300,
      offset: 1800,
      triggerHook: 0.3,
    })
      .setPin(".section2pin")
      .setClassToggle(".section2pin--1", "fade-in")
      .addTo(controller);

    const section_b = new ScrollMagic.Scene({
      triggerElement: ".section__2__trigger",
      offset: 1800,
      triggerHook: 0.3,
    })
      .setTween(".peta-2b", 0.3, {
        opacity: 1,
      })
      .addTo(controller);

    const section_2c = new ScrollMagic.Scene({
      triggerElement: ".section__2__trigger",
      duration: 300,
      offset: 2100,
      triggerHook: 0.3,
    })
      .setClassToggle(".section2pin--2", "fade-in")
      .addTo(controller);

    const section_2d = new ScrollMagic.Scene({
      triggerElement: ".section__2__trigger",
      offset: 2100,
      triggerHook: 0.3,
    })
      .setTween(".peta-2c", 0.3, {
        opacity: 1,
      })
      .addTo(controller);
  };

  // - init
  const init = () => {
    handleSection2();
  };

  return {
    init,
  };
})();

export default Section2;
